export default {
    dependencies: ['$element', 'trackingservice'],
    callable(element, trackingService) {
        const submitButton = element.querySelector(
            'button[data-validation-required]'
        );
        const textArea = element.querySelector('textarea[data-review-text]');

        function isValid() {
            const hasComment = textArea && textArea.value !== '';
            const hasCheckedStar = element.querySelectorAll(
                'input[type=radio]:checked'
            ).length;

            return hasComment && hasCheckedStar;
        }

        function toggleSubmitButton() {
            submitButton.disabled = !isValid();
        }

        function handleSubmit() {
            if (element.getAttribute('data-edit') === 'true') {
                trackingService.trackLater(
                    'review.modify-review.done',
                    'success',
                    ''
                );
            } else {
                trackingService.trackLater(
                    'review.give-review.done',
                    'success',
                    'activity'
                );
            }

            return true;
        }

        element.addEventListener('submit', handleSubmit);

        if (submitButton) {
            const inputs = element.querySelectorAll('input[type=radio]');
            Array.from(inputs).forEach(input => {
                input.addEventListener('change', toggleSubmitButton);
            });

            if (textArea) {
                textArea.addEventListener('change', toggleSubmitButton);
                textArea.addEventListener('input', toggleSubmitButton);
            }

            toggleSubmitButton();
        }

        if (element.getAttribute('data-edit') === 'true') {
            trackingService.trackEvent(
                'review.modify-review.start',
                'start',
                ''
            );
        } else {
            trackingService.trackEvent(
                'review.give-review.rate-user',
                '',
                'activity'
            );
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/userreview.js